import React from "react";

export default function HistorySkeleton() {
  return (
    <div className="min-h-screen bg-[#f8f9ff] pt-6 pb-12 antialiased animate-pulse">
      <div className="max-w-3xl mx-auto px-4 mt-2 md:mt-8 space-y-6">
        <div className="bg-white rounded-2xl p-5 border border-gray-100 h-[155px] flex flex-col justify-between">
          <div className="flex justify-between items-start">
            <div className="space-y-2">
              <div className="h-3 bg-gray-200 rounded w-24"></div>
              <div className="h-7 bg-gray-200 rounded w-40"></div>
            </div>
            <div className="space-y-2 flex flex-col items-end">
              <div className="h-3 bg-gray-200 rounded w-16"></div>
              <div className="h-7 bg-gray-200 rounded w-10"></div>
            </div>
          </div>

          <div className="space-y-2 pt-2">
            <div className="h-3 bg-gray-200 rounded w-48"></div>
            <div className="h-2.5 bg-gray-200 rounded w-full"></div>
          </div>
        </div>

        <div className="space-y-4">
          <div className="flex justify-between items-center px-1">
            <div className="h-5 bg-gray-200 rounded w-28"></div>
          </div>

          {[1, 2, 3].map((n) => (
            <div
              key={n}
              className="bg-white rounded-xl p-4 border border-gray-100 h-[76px] flex items-center justify-between"
            >
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                <div className="space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-36"></div>
                  <div className="h-3 bg-gray-200 rounded w-24"></div>
                </div>
              </div>

              <div className="flex items-center gap-4">
                <div className="space-y-2 flex flex-col items-end">
                  <div className="h-4 bg-gray-200 rounded w-20"></div>
                  <div className="h-3 bg-gray-200 rounded w-12"></div>
                </div>

                <div className="w-8 h-8 bg-gray-200 rounded-lg"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
